import React, { useState, useEffect } from 'react';
import { X, FileText } from 'lucide-react';
import API from '../utils/axios';

const renderTerms = (text) => {
  if (!text) return <p className="text-gray-400">Belum ada Syarat &amp; Ketentuan.</p>;
  const lines = text.split('\n');
  const nodes = [];
  let listBuffer = [];
  const flushList = (key) => {
    if (listBuffer.length) {
      nodes.push(
        <ul key={`ul-${key}`} className="list-disc list-inside space-y-1 mb-3 text-gray-300">
          {listBuffer.map((l, i) => <li key={i}>{l}</li>)}
        </ul>
      );
      listBuffer = [];
    }
  };
  lines.forEach((raw, idx) => {
    const line = raw.trim();
    if (!line) { flushList(idx); nodes.push(<div key={`sp-${idx}`} className="h-2" />); return; }
    if (line.startsWith('## ')) {
      flushList(idx);
      nodes.push(<h3 key={idx} className="text-lg font-bold text-white mt-4 mb-2">{line.replace(/^##\s+/, '')}</h3>);
    } else if (line.startsWith('# ')) {
      flushList(idx);
      nodes.push(<h2 key={idx} className="text-xl font-black text-white mt-4 mb-2">{line.replace(/^#\s+/, '')}</h2>);
    } else if (line.startsWith('- ')) {
      listBuffer.push(line.replace(/^-\s+/, ''));
    } else {
      flushList(idx);
      nodes.push(<p key={idx} className="text-gray-300 leading-relaxed mb-2">{line}</p>);
    }
  });
  flushList('end');
  return nodes;
};

export const TermsModal = ({ isOpen, onClose }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    API.get('/settings', { params: { _t: Date.now() } })
      .then(({ data }) => setContent(data?.terms_content || ''))
      .catch(() => setContent(''))
      .finally(() => setLoading(false));
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="terms-modal">
      <div className="modal-content p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-black text-white flex items-center gap-2">
            <FileText className="text-[#FFD60A]" size={28} /> Syarat &amp; Ketentuan
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white" data-testid="close-terms-modal">
            <X size={24} />
          </button>
        </div>
        <div className="max-h-[60vh] overflow-y-auto pr-2" data-testid="terms-modal-content">
          {loading ? (
            <div className="text-gray-400">Loading...</div>
          ) : (
            renderTerms(content)
          )}
        </div>
        <div className="mt-6 text-center">
          <button onClick={onClose} className="btn-primary px-8" data-testid="ok-terms-modal">
            OK, Saya Mengerti
          </button>
        </div>
      </div>
    </div>
  );
};
